module.exports = __webpack_public_path__ + "img/gallery-03.d820e323.jpg";